import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatContext = createContext();

// Contexto simplificado para un único agente (agentId siempre el mismo)
export const ChatProvider = ({ children, agentId, communicationType = 'http', httpOptions = {} }) => {
  const [conversation, setConversation] = useState({
    messages: [],
    conversationID: "",
    agentIsTyping: false,
    showStopButton: false,
    isSendMessageClicked: false,
    hasMessages: false
  });
  
  const [communicationConfig] = useState({
    type: communicationType,
    httpOptions: httpOptions,
    agentId: agentId
  });

  const setMessages = useCallback((messagesOrUpdater) => {
    setConversation(prev => {
      // Support both direct array and callback function (like setState)
      const newMessages = typeof messagesOrUpdater === 'function' 
        ? messagesOrUpdater(prev.messages)
        : messagesOrUpdater;
      const safeMessages = Array.isArray(newMessages) ? newMessages : [];
      return {
        ...prev,
        messages: safeMessages,
        hasMessages: safeMessages.length > 0
      };
    });
  }, []);

  const setAgentIsTyping = useCallback((isTyping) => {
    setConversation(prev => ({ ...prev, agentIsTyping: isTyping }));
  }, []);

  const setConversationID = useCallback((conversationID) => {
    setConversation(prev => ({ ...prev, conversationID }));
  }, []);

  const setShowStopButton = useCallback((showStopButton) => {
    setConversation(prev => ({ ...prev, showStopButton }));
  }, []);

  const setIsSendMessageClicked = useCallback((isSendMessageClicked) => {
    setConversation(prev => ({ ...prev, isSendMessageClicked }));
  }, []);

  const clearConversation = useCallback(() => {
    setConversation({
      messages: [],
      conversationID: "",
      agentIsTyping: false,
      showStopButton: false,
      isSendMessageClicked: false,
      hasMessages: false
    });
  }, []);

  const contextValue = {
    conversation,
    communicationConfig,
    setMessages,
    setAgentIsTyping,
    setConversationID,
    setShowStopButton,
    setIsSendMessageClicked,
    clearConversation
  };

  return (
    <ChatContext.Provider value={contextValue}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};

